import { makeStyles } from '@material-ui/core';
import commonStyles from 'config/commonStyles';
import { theme } from 'config/theme';

export const useStyles = makeStyles({
    ...commonStyles,
    root: {
        minHeight: '100%',
        width: '100%',
        '& .MuiTableCell-body.MuiTableCell-root:first-child': {
            paddingLeft: 25,
        },
        /*  '& .MuiTableContainer-root': {
            flexGrow: 0,
            maxHeight: 550,
        }, */
        '& .MuiPaper-root.MuiPaper-elevation1.MuiPaper-rounded': {
            height: '93%',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
        },
        '& th.MuiTableCell-root:not(:first-child)': {
            height: '10px',
            '& .MuiToolbar-root.MuiToolbar-regular.search-input.MuiToolbar-gutters': {
                justifyContent: 'start',
            },
        },
    },
    baseChip: {
        backgroundColor: 'transparent',
        '& .MuiChip-label': {
            fontWeight: 600,
            display: 'inline-flex',
            alignItems: 'center',
            height: 24,
            padding: '0 10px',
            borderRadius: 12,
            fontSize: 12,
            letterSpacing: 0.4,
        },
    },
    activeChip: {
        '& .MuiChip-label': {
            background: 'rgba(95, 207, 85, 0.18)',
            color: '#2e7d32',
        },
    },
    usedChip: {
        '& .MuiChip-label': {
            background: 'rgba(153, 86, 126, 0.16)',
            color: '#99567E',
        },
    },
    expiredChip: {
        '& .MuiChip-label': {
            background: 'rgba(198, 40, 40, 0.12)',
            color: '#c62828',
        },
    },
    uploadContainer: {
        border: `2px dashed ${theme.palette.grey[400]}`,
        margin: theme.spacing(2),
        borderRadius: theme.spacing(1),
        padding: theme.spacing(4),
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
        transition: 'all 0.3s ease',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: 'rgba(153, 86, 126, 0.05)',
        },
        '&.drag-over': {
            borderColor: theme.palette.primary.main,
            backgroundColor: 'rgba(153, 86, 126, 0.1)',
        },
    },
    uploadIcon: {
        fontSize: 48,
        color: theme.palette.grey[500],
    },
    uploadText: {
        marginBottom: theme.spacing(1),
        fontSize: '16px',
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    supportedText: {
        fontSize: '14px',
        color: theme.palette.text.secondary,
    },
    uploadButton: {
        backgroundColor: '#A56A8B',
        color: 'white',
        padding: theme.spacing(1.5, 4),
        borderRadius: theme.spacing(1),
        fontSize: '16px',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: '#99567E',
        },
    },
    hiddenInput: {
        display: 'none',
    },
    fileName: {
        fontSize: '14px',
        color: theme.palette.primary.main,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
    },
    removeFileButton: {
        padding: theme.spacing(0.5),
        color: theme.palette.grey[500],
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            color: theme.palette.error.main,
        },
    },
    errorText: {
        marginTop: theme.spacing(1),
        fontSize: '14px',
        color: theme.palette.error.main,
    },
    dataContainer: {
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
    },
    selectRoot: {
        '& .MuiSelect-select': {
            padding: '10px 12px 10px 15px',
        },
    },
    buttonRoot: {
        width: 150,
        padding: '7px 20px 7px 20px',
        marginLeft: 15,
        '& .MuiButton-label': {
            justifyContent: 'start',
            textTransform: 'none',
        },
    },
    filterButton: {
        width: 150,
        padding: '7px 20px 7px 20px',
        marginLeft: 15,
    },
    vouchersTableRoot: {
        minWidth: 900,
        '& th.MuiTableCell-root': {
            padding: '12px 16px 12px 12px',
        },
        '& td.MuiTableCell-root:first-child': {
            paddingLeft: 16,
        },
        '& th.MuiTableCell-root:first-child': {
            paddingLeft: 16,
        },
    },
});
